module.exports = __webpack_public_path__ + "static/media/left-bottom-banner-effect.444a5f41.svg";